import { afterNextRender, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'black-social-share',
  templateUrl: './social-share.component.html',
  styleUrl: './social-share.component.css',
  standalone: false,
})
export class SocialShareComponent {
  private route = inject(ActivatedRoute);

  message = encodeURIComponent(
    '🚀 Exciting Opportunity! Enroll in this course now to boost your skills and knowledge. Check out the details here:'
  );

  pageUrl = '';

  constructor() {
    afterNextRender(() => {
      this.pageUrl = encodeURIComponent(window.location.href);
    });
  }

  shareToWhatsapp() {
    const whatsappUrl = `https://wa.me/?text=${this.message}%20${this.pageUrl}`;
    window.open(whatsappUrl, '_blank');
  }

  shareToFacebook() {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.pageUrl}&quote=${this.message}`;
    window.open(facebookUrl, '_blank');
  }

  shareToLinkedIn() {
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${this.pageUrl}`;
    window.open(linkedInUrl, '_blank');
  }

  shareToTelegram() {
    const telegramUrl = `https://t.me/share/url?url=${this.pageUrl}&text=${this.message}`;
    window.open(telegramUrl, '_blank');
  }

  copyUrl(): void {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl).catch((err) => {
      console.error('Failed to copy URL: ', err);
    });
  }
}
